// ```sheet blocks, shown as interactive grids
import {
  findSheets,
  serializeTable,
  type Sheet,
} from '@/app/sheet/sheet';
import { type BlockKind } from './blocks';
import { SheetGrid } from './SheetGrid';

export const sheetBlocks: BlockKind<Sheet> = {
  name: 'sheet',
  find: findSheets,
  draw: (sheet, on) => (
    <SheetGrid
      table={sheet.table}
      onChange={table => on.replace(serializeTable(table))}
      onUndo={on.undo}
      onRedo={on.redo}
      onEditText={on.editText} />
  ),
};

export const newSheet = `\`\`\`sheet\n${
  serializeTable([['', ''], ['', '']])
}\`\`\`\n`;
